// Copyright (c) 2025. CYBERKOALA LLC. All Rights Reserved.
// Proprietary license.

import { createContext } from 'react';
import { emptyFn } from '@/lib/utils.ts';

export type ViewType = 'nav' | 'servers' | 'channel' | 'members';

interface ViewContextProps {
  view: ViewType;
  setView: (view: ViewType) => void;
}

export const ViewContext = createContext<ViewContextProps>({
  view: 'nav',
  setView: emptyFn,
});
